/**
 * Contact prefill from URL query params — lets marketing pages (e.g.
 * kloudmd.com/get-started) hand off a visitor's name/email so they don't
 * retype them in the widget.
 *
 * Supported params: `full_name` (split on whitespace into first/last),
 * or explicit `first_name` / `last_name`, plus `email`.
 *
 * These are visitor-typed values arriving via an attacker-controllable URL,
 * so they are length-capped and stripped of HTML-significant characters here,
 * and must still only be applied via `input.value =` or escaped interpolation
 * — never raw innerHTML.
 *
 * Note: the same param names double as lead-CREATION inputs on the photo
 * upload-link flow (`&upload=` in widget.js). That flow is unaffected — this
 * module only reads.
 */

const clean = (v) => {
    v = String(v || '').replace(/[<>"'&`]/g, '').trim();
    return v.length > 120 ? '' : v;
};

const search = (window.location.search || '').replace(/^\?+/, '?');
const q = new URLSearchParams(search);

let first = clean(q.get('first_name'));
let last = clean(q.get('last_name'));
if (!first && !last) {
    const full = clean(q.get('full_name')).split(/\s+/).filter(Boolean);
    first = full.shift() || '';
    last = full.join(' ');
}

const email = clean(q.get('email'));

export const urlPrefill = {
    first_name: first,
    last_name: last,
    email,
    full_name: [first, last].filter(Boolean).join(' '),
};

/**
 * Fill the gaps in a lead-shaped object with the URL prefill. Server-known
 * values always win — this only supplies fields the lead doesn't have yet.
 */
export function applyLeadPrefillDefaults(lead) {
    const out = { ...(lead || {}) };
    // Name is all-or-nothing: don't graft a URL last_name onto a server first_name.
    if (!out.first_name && !out.last_name && urlPrefill.first_name) {
        out.first_name = urlPrefill.first_name;
        if (urlPrefill.last_name) out.last_name = urlPrefill.last_name;
    }
    if (!out.email && urlPrefill.email) out.email = urlPrefill.email;
    return out;
}
